import { SpaceContext } from '@eggplant/context'
import { navigate } from '@reach/router'
import {
  useContext,
  useEffect
} from 'react'
import useConfirm from './useConfirm'

interface Props {
  navTo: string
}

const usePreventLeaveSpace = ({
  navTo
}: Props) => {
  const spaceContext = useContext(SpaceContext)

  const {
    getConfirmation,
    isLeaveWithSave,
    Confirmation
  } = useConfirm(
    () => undefined,
    'Leave space',
    'Stay',
    'You\'re about to leave this space.'
  )

  const getLeaveSpaceConfirmation = () => {
    void getConfirmation('You will be logged out from the current space. Do you want to continue?')
  }

  useEffect(() => {
    if (isLeaveWithSave === true) {
      if (spaceContext?.selectedSpaceId) {
        spaceContext.setSelectedSpaceId('')
      }

      void navigate(navTo)
    }
  }, [isLeaveWithSave, navTo, spaceContext])

  return {
    getLeaveSpaceConfirmation,
    Confirmation
  }
}

export default usePreventLeaveSpace
